/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetActiveJobGuidsAsync$Json$Params {
  companyGuid: string;
}

export function getActiveJobGuidsAsync$Json(http: HttpClient, rootUrl: string, params: GetActiveJobGuidsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, getActiveJobGuidsAsync$Json.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<string>>;
    })
  );
}

getActiveJobGuidsAsync$Json.PATH = '/integrations/greenhouse/companies/{companyGuid}/active-jobs';
